import { LanguagesStore, Language } from 'traveldesk-ui'
import { useEffect } from 'react'
import { ApplicationState } from '../store'
import { useDispatch, useSelector } from 'react-redux'
interface Props {
    isOffers: boolean
    selector: (state: any) => LanguagesStore.State
    enabled?: boolean
}
export const useLanguages = (props: Props) => {
    const dispatch = useDispatch()
    const languages = useSelector(props.selector)
    useEffect(() => {
        if (props.enabled !== false && languages.languages.length === 0) {
            dispatch(LanguagesStore.actionCreators.requestLanguages(props.isOffers))
        }
    }, [props.enabled, props.isOffers])
    return languages
}
export const useLanguagesManageTable = (enabled = true) =>
    useLanguages({
        isOffers: false,
        selector: (state: ApplicationState) => state.languages,
        enabled,
    })
